module.exports = __webpack_public_path__ + "img/img_owned_patent09.60ab269e.jpg";